module.exports = __webpack_public_path__ + "img/2-1.7cc19032.png";